import * as consts from "../consts";
import axios from "axios";

function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function setBusy(busy, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSY,
      payload: busy,
    });
    resolve();
  });
}

export function getCharities(categoryID, dispatch) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${consts.SERVICE_URL}/Charities/${categoryID}/featured`, {})
      .then((response) => {
        let charities = response.data.charities.filter(
          (charity, index, array) => {
            return (
              charity.ein &&
              charity.ein.length > 0 &&
              index ==
                array.findIndex((item) => {
                  return item.ein == charity.ein;
                })
            );
          }
        );
        dispatch({
          type: consts.ACTION_SET_CHARITIES,
          payload: charities,
        });
        setBusy(false, dispatch);
        resolve(charities);
      })
      .catch((exception) => {
        handleError(exception, `Unable to retrieve charities`, dispatch);
        setBusy(false, dispatch);
        reject(exception);
      });
  });
}
